import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.ZOOM_DEVICE],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZOOM_DEVICE),
      title: 'Desk Phones & Headsets',
      planType: planTypes.ZOOM_DEVICE,
      configDescription: 'configDescription',
      // same with desk phones addon desc.
      description: this.$t('billing.hw.desk_phones.addon.desc'),
    };
  }
};
